module.exports = __webpack_public_path__ + "img/Autonomous.9ec1a4e9.svg";